var _title, _desc, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgOtherItems = function SvgOtherItems(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "others")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.-ICONS-AND-SYMBOLS",
    transform: "translate(-1160.000000, -371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "others",
    transform: "translate(1158.000000, 369.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,9.105 C11,10.21 10.104,11.105 9,11.105 C7.896,11.105 7,10.21 7,9.105 C7,8 7.896,7.105 9,7.105 C10.104,7.105 11,8 11,9.105 L11,9.105 Z M11,15.105 C11,16.21 10.104,17.105 9,17.105 C7.896,17.105 7,16.21 7,15.105 C7,14 7.896,13.105 9,13.105 C10.104,13.105 11,14 11,15.105 L11,15.105 Z M17,9.105 C17,10.21 16.104,11.105 15,11.105 C13.896,11.105 13,10.21 13,9.105 C13,8 13.896,7.105 15,7.105 C16.104,7.105 17,8 17,9.105 L17,9.105 Z M4,2 C2.896,2 2,2.896 2,4 L2,20 C2,21.105 2.896,22 4,22 L20,22 C21.105,22 22,21.105 22,20 L22,4 C22,2.896 21.105,2 20,2 L4,2 Z",
    id: "dice-[#21]",
    fill: "#1B1C1D"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOtherItems, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/otherItems.3bdbe05a.svg";
export { ForwardRef as ReactComponent };